import { inject, Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Veterinarian } from '@tcc-mono/vandijk/shared/data-access/models';
import { VeterinarianService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VeterinarianRepository extends CoreRepository<Veterinarian> {
  public veterinarians$: Observable<Veterinarian[]> = this.entities$;
  public selectedVeterinarian$: Observable<Veterinarian> = this.activeEntity$;

  public constructor() {
    super({ name: 'veterinarians' }, inject(VeterinarianService));
  }

  public addVeterinarian = (veterinarian: Partial<Veterinarian>): Observable<Veterinarian> => {
    return this.addEntity(veterinarian);
  };

  public updateVeterinarian = (
    veterinarianId: number,
    veterinarian: Veterinarian
  ): Observable<Veterinarian> => {
    return this.updateEntity(veterinarianId, veterinarian);
  };

  public getVeterinarian = (veterinarianId: number): Observable<Veterinarian> => {
    return this.getEntity(veterinarianId);
  };

  public removeVeterinarian = (veterinarianId: number): Observable<unknown> => {
    return this.removeEntity(veterinarianId);
  };

  public setActiveVeterinarian = (veterinarianId: number): void => {
    this.setActiveEntity(veterinarianId);
  };
}
